export interface SourceItem {
	id: number
	order?: number
	alias?: string
	stereotype?: SourceEnums.StereotypeEnum
	objectType?: SourceEnums.ObjectTypeEnum
	expression?: string
	sourceContext?: string
	ownerName?: string
	ownerId?: number
	objectId?: number
	objectCode?: string
	objectUuid?: string
	objectCustom?: string
	uuid?: string
	rightAction?: string
}

export namespace SourceEnums {
	export enum StereotypeEnum {
		FROM = 'from',
		JOIN = 'join',
		LEFT_JOIN = 'left join',
		LEFT_OUTER_JOIN = 'left outer join',
		RIGHT_JOIN = 'right join',
		RIGHT_OUTER_JOIN = 'right outer join',
		FULL_OUTER_JOIN = 'full outer join',
		CROSS_JOIN = 'cross join',
		UNION = 'union',
		UNION_ALL = 'union all',
	}
	export enum ObjectTypeEnum {
		TABLE = 'TABLE',
		VIEW = 'VIEW',
		SUB_SELECT = 'SUB_SELECT',
		DUMMY = 'DUMMY',
	}
}
